import { Tour } from "nextstepjs";

const recipesGuide: Tour[] = [
  {
    tour: "recipesTour",
    steps: [
      {
        icon: "",
        title: "",
        content:
          "Save your favorite recipes for easy access by adding them to My Recipe Lists.",
        selector: "#recipe_favorite_0",
        side: "top-right",
        showControls: true,
        showSkip: true,
        pointerPadding: 5,
        pointerRadius: 10,
      },
    ],
  },
];

export default recipesGuide;
